import { SimpleParamFilter } from '../../shared/ui/param-filters/simple-param-filter';
import { ManagerUrlParamsFilter } from 'entities/filters/manager-url-params-filter';
import { DateUrlParamsFilter } from 'entities/filters/date-url-params-filter';
import { useMimetypeDropdown } from 'entities/files/files-type-picker/dropdown.hook';
import { FilterWrapper, ValueFormatterContext } from 'shared/ui/filter/filter-wrapper';
import { Stack } from '@mui/material';
import { useManagersDropdownList } from 'features/user/user-picker/ui';

export const FileListFilter = () => {
  const mimetypeItems = useMimetypeDropdown();
  const MIMETYPES = mimetypeItems.items.map((item) => ({ label: item.mimetype, id: item.mimetype }));
  const { items: managers } = useManagersDropdownList();

  const managerValueFormatter = ({ value }: ValueFormatterContext) => {
    const manager = managers.find((m) => String(m.id) === value);
    return manager ? `${manager.firstName} ${manager.secondName || ''}`.trim() : value;
  };

  const mimetypeFormatter = ({ value }: ValueFormatterContext) => {
    const option = MIMETYPES.find((item) => String(item.id) === value);
    return option ? option.label : value;
  };

  return (
    <FilterWrapper>
      <FilterWrapper.Item label="Загрузил" queryKeys="uploadedById" valueFormatter={managerValueFormatter}>
        <ManagerUrlParamsFilter queryParamName="uploadedById" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Тип файла" queryKeys="mimetype" valueFormatter={mimetypeFormatter}>
        <SimpleParamFilter queryParamName="mimetype" items={MIMETYPES} label="Тип файла" />
      </FilterWrapper.Item>

      <FilterWrapper.Item
        label="Дата загрузки"
        queryKeys={['createdAtFrom', 'createdAtTo']}
        summaryFormatter={({ searchParams }) => {
          const from = searchParams.get('createdAtFrom');
          const to = searchParams.get('createdAtTo');
          if (!from && !to) return 'Дата загрузки';
          if (from && to) return `Загружен: ${from} — ${to}`;
          return `Загружен: ${from || to}`;
        }}
      >
        <Stack spacing={1.5}>
          <DateUrlParamsFilter queryParamName={'createdAtFrom'} label="Загружен с" />
          <DateUrlParamsFilter queryParamName={'createdAtTo'} label="Загружен по" />
        </Stack>
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};
